import { Loading } from 'components/loading'
import { RasaContext } from 'context'
import * as React from 'react'
import { connect } from 'react-redux'
import * as Router from 'router'
import * as Modals from 'shared/modals'
import { isValidSectionName } from '../utility/utils'
interface AddSourceSectionState extends Modals.ModalComponentState {
  name: string,
  displayName: string,
}

interface AddSourceSectionProps extends Modals.ModalComponentProps {
  sectionData: any,
  push: any,
  name?: string,
  displayName?: string,
  isEditMode?: boolean,
  editId?: string,
  createOrUpdate: (payload: any) => Promise<any>
}

export class AddSourceSectionModalComponent extends Modals.GenericModalComponent<AddSourceSectionProps,
  AddSourceSectionState> {
  public static contextType = RasaContext
  public static key: string = 'addSourceSection'
  public static defaultProps = {
    closeButtonText: 'Close',
    saveText: 'Save',
    secondAction: Modals.ModalActionType.BUTTON,
    title: 'Add a Section',
  }
  private isSaveButtonDisabled: boolean = false
  constructor(props: AddSourceSectionProps) {
    super(props, AddSourceSectionModalComponent.key, 'Add a section')
    this.state = {
      name: props.name || '',
      displayName: props.displayName || '',
      isSaving: false,
    }
  }

  public componentWillReceiveProps(nextProps) {
    // reset the timer if children are changed
    if (nextProps.name && nextProps.name !== this.props.name) {
      this.setState({name: nextProps.name});
    }
    if (nextProps.displayName && nextProps.displayName !== this.props.displayName) {
      this.setState({displayName: nextProps.displayName});
    }
  }

  protected renderChildren(data: any) {
    // In edit mode, pass the current section ID to exclude it from validation
    const currentSectionId = this.props.isEditMode ? parseInt(this.props.editId || '0', 10) : 0
    this.isSaveButtonDisabled = isValidSectionName(this.props.sectionData, this.state.name, currentSectionId)
    return (
      <div className="add-section-modal-body">
        {this.state.isSaving
        ? <Loading size="64"/>
        : <div style={{padding: '0 4px'}}>
            <div style={{marginBottom: '20px'}}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 600,
                color: '#333'
              }}>
                Name
              </label>
              <input
                type="text"
                value={this.state.displayName}
                placeholder="Enter display name..."
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  backgroundColor: '#fff',
                  transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6'
                  e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)'
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#d1d5db'
                  e.target.style.boxShadow = 'none'
                }}
                onChange={(e) => {
                  e.preventDefault()
                  const displayName = e.target.value
                  if (this.props.isEditMode) {
                    // In edit mode, only update display name, don't change code
                    this.setState({ displayName })
                  } else {
                    // In create mode, update both display name and code
                    this.setState({ displayName, name: displayName })
                  }
                }}
              />
            </div>
            <div style={{marginBottom: '20px'}}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 600,
                color: '#333'
              }}>
                Code
              </label>
              <input
                type="text"
                value={this.state.name}
                placeholder="Enter section code..."
                readOnly={this.props.isEditMode}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  backgroundColor: this.props.isEditMode ? '#f9fafb' : '#fff',
                  color: this.props.isEditMode ? '#6b7280' : '#333',
                  cursor: this.props.isEditMode ? 'not-allowed' : 'text',
                  transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                  outline: 'none'
                }}
                onFocus={(e) => {
                  if (!this.props.isEditMode) {
                    e.target.style.borderColor = '#3b82f6'
                    e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)'
                  }
                }}
                onBlur={(e) => {
                  if (!this.props.isEditMode) {
                    e.target.style.borderColor = '#d1d5db'
                    e.target.style.boxShadow = 'none'
                  }
                }}
                onChange={(e) => {
                  if (!this.props.isEditMode) {
                    e.preventDefault()
                    this.setState({ name: e.target.value })
                  }
                }}
              />
              <small style={{
                color: '#6b7280',
                fontSize: '12px',
                display: 'block',
                marginTop: '6px',
                fontStyle: 'italic'
              }}>
                This code should be used in your custom templates
              </small>
            </div>
          </div>
        }
        <div>
        { this.isSaveButtonDisabled
        ? <div className="invalid-source-name-container">You already have a section with this name</div>
        : null}
        </div>
      </div>
    )
  }

  protected close = (data: any) => {
    this.setState({
      name: '',
      displayName: '',
    })
    return this.props.closeModal(AddSourceSectionModal.key)
  }
  protected xButtonClick(data: any) {
    this.close(data)
  }

  protected saveDisabled(data: any): boolean {
    const nameEmpty = this.state.name === ''
    const displayNameEmpty = !this.props.isEditMode && this.state.displayName === ''
    return nameEmpty || displayNameEmpty ? true : this.isSaveButtonDisabled
  }

  protected doSave(data: any) {
    const payload = { name: this.state.name, display_name: this.state.displayName }
    return this.props.createOrUpdate(payload).then(() => {
      this.setState({
        isSaving: false,
        name: '',
        displayName: '',
      })
    });
  }
}

export const AddSourceSectionModal = connect(
  null,
  {
    push: Router.push,
  },
)(AddSourceSectionModalComponent)
